import React, { useState } from 'react'
import { Card, Badge, Button, Collapse } from 'react-bootstrap'
import ReactMarkdown from 'react-markdown'

export default function Job({ job }) {
    const [open, setOpen] = useState(false);
    return (
        <Card className="mb-3">
            <Card.Body>
                <div className="d-flex justify-content-between">
                    <div>
                        <Card.Title>
                            {job.title} - <span className="text-muted font-weight-light">{job.company}</span>
                        </Card.Title>
                        <Card.Subtitle className="text-muted mb-2">
                            {(new Date(job.created_at)).toLocaleDateString()}
                        </Card.Subtitle>
                        <Badge variant="primary" className="mr-2" >{job.type}</Badge>
                        <Badge variant="secondary" >{job.location}</Badge>
                        <div style={{ wordBreak: "break-all" }}>
                            <ReactMarkdown source={job.how_to_apply} />
                        </div>
                    </div>
                    <img className="d-none d-md-block" src={job.company_logo} alt={job.company} height="50"></img>
                </div>
                <Button onClick={() => setOpen(prevOpen => { return !prevOpen })} className="mb-2">
                    {open ? "Hide Details" : "View Details"}
                </Button>
                <Collapse in={open} style={{ wordBreak: "break-all" }}>
                    <ReactMarkdown source={job.description}></ReactMarkdown>
                </Collapse>
            </Card.Body>
        </Card>
    )
}
